let activeDownloads = 0;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(activeDownloads));

export const subscribeToDownloads = (listener) => {
  listeners.add(listener);
  listener(activeDownloads);
  return () => listeners.delete(listener);
};

export const trackDownload = (download, { defer = false } = {}) => (...args) => {
  activeDownloads += 1;
  notify();
  const startedAt = Date.now();

  const run = async () => {
    try {
      // Let React paint before generating files synchronously in the browser.
      if (defer) {
        await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      }
      return await download(...args);
    } finally {
      // Keep short downloads visible long enough to confirm the click registered.
      const remaining = 350 - (Date.now() - startedAt);
      if (remaining > 0) {
        await new Promise((resolve) => setTimeout(resolve, remaining));
      }
      activeDownloads -= 1;
      notify();
    }
  };

  return run();
};
